enum WatchSliderSpeed {
    NORMAL = 3,
    HOVER = .9,
}

class WatchCarousel {
    protected itemsContainer = '.wrap-watch-slider';
    protected paused = false;
    protected time: number;
    protected carouselWidth: number;
    protected speed: WatchSliderSpeed;

    constructor() {
        $(document).on('mouseover', this.itemsContainer, () => this.setSpeed(WatchSliderSpeed.HOVER))
        $(document).on('mouseout', this.itemsContainer, () => this.setSpeed(WatchSliderSpeed.NORMAL))

        const items = $(this.itemsContainer).find('.items')
        this.carouselWidth = items.outerWidth()

        if (!this.carouselWidth) {
            return;
        }

        const clonesQuantity = Math.ceil($(window).outerWidth() / this.carouselWidth);


        for (let i = 0; i < clonesQuantity; i++) {
            const itemsClone = items.clone().addClass('clone')
            let itemsLozad = itemsClone.find('.lozad');
            itemsLozad.removeClass('lozad');
            itemsLozad.each((i, e) => {
                $(e).attr('src', $(e).data('src'))
            })
            $(this.itemsContainer).append(itemsClone)
        }

        this.resetSlider()
        this.play()
    }

    pause() {
        this.paused = true;
    }

    play() {
        this.paused = false;
        this.speed = WatchSliderSpeed.NORMAL
        this.loop()
    }

    setSpeed(value: WatchSliderSpeed) {
        this.speed = value;
    }

    loop() {
        if (this.paused) {
            return;
        }

        let offset = this.getOffset()

        if (Math.abs(offset) >= Math.abs(this.carouselWidth)) {
            this.resetSlider()
            offset = this.getOffset()
        }

        $(this.itemsContainer).css('transform', `translateX(${offset}px)`);


        this.time -= this.speed;
        requestAnimationFrame(this.loop.bind(this));
    }

    getOffset() {
        return this.time / 3.4;
    }

    resetSlider() {
        this.time = 1
    }
}

export default WatchCarousel;
